<template>
  <nav>
    <v-app-bar
      v-if="currentRoute !== 'signin'"
      flat
      app
      clipped-left 
      :color="bannerColor">
      <v-app-bar-nav-icon
        large
        class="white--text"
        @click="drawer = !drawer"
      />
      <v-spacer />
      <div class="text-h6 white--text">{{bannerName}}</div>
      <v-spacer />

      <v-icon
        v-if="environment !== 'production'"
        large
        class="white--text"
        :class="isOnline ? 'mr-4' : ''">
        mdi-dev-to
      </v-icon>
       <v-icon
          v-show="!isOnline" 
          class="mx-4 white--text"
          large>
          mdi-cloud-off-outline
        </v-icon>

        <v-btn
          small fab
          :color="bannerColor"
          v-show="isMobileDevice"
        >
          <v-icon
            @click="toggleScreen()"
            outlined
          >
            {{ (isFullScreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen') }}
          </v-icon>
        </v-btn>
    </v-app-bar>

    <v-navigation-drawer 
      v-if="currentRoute !== 'signin'"
      v-model="drawer"
      app
      clipped>
      <v-container>
        <v-row>
          <v-col>
            <v-card
              width="300"
              color="transparent"
              flat>
              <div style="text-align: center;">
                <img
                  style="vertical-align: middle;"
                  src="@/assets/img/favicon-96x96.png"
                  alt="Egg Picker Logo" />
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <hr color="darkgray" style="height:2px" />

      <v-list style="padding: 0;">
        <v-list-item 
          v-for="link in links"
          :key="link.text"
          :to="link.route"
          :disabled="link.disabled"
          :exact="link.exact">

          <v-list-item-icon class="mr-4">
            <v-icon :class="link.indent ? 'ml-10': ''" :disabled="link.disabled">{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <hr color="darkgray" style="height:2px" />

      <v-list style="padding: 0;">
        <v-list-item
          v-for="link in links2"
          :key="link.text"
          :to="link.route"
          :disabled="link.disabled"
          :exact="link.exact">

          <v-list-item-icon class="mr-4">
            <v-icon :class="link.indent ? 'ml-10': ''" :disabled="link.disabled">{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav> 
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  data() {
    return {
      drawer: false,
      environment: null,
      isFullScreen: false
    }
  },
  mounted() {
      window.addEventListener("fullscreenchange", this.handleScreenChange);
      window.addEventListener("webkitfullscreenchange", this.handleScreenChange, false);
  },
  created() {
    this.environment = process.env.VUE_APP_MODE;
  },
  computed: {
    ...mapState(['settings','isOnline']),
    currentRoute() {
      return this.$route.name;
    },
    bannerName() {
      switch(this.$route.name)
      {
        case "Egg Vision Groups":
        case "Egg Vision":
          return "Egg Vision";
        case "Egg Collection Groups":
        case "Egg Collection":
          return "Egg Collection"
        default:
          return "Cobb Egg Picker"
      }
    },
    bannerColor() {
      if (this.$route.name.includes('Egg Collection Groups', 'Egg Collection')) 
        return 'tertiary';
      else if (this.$route.name.includes('Egg Vision', 'Egg Vision Collection'))
        return 'secondary';
      else
      return 'primary';
    },
    // isStandAlone() {
    //   if (window.matchMedia('(display-mode: standalone)').matches)
    //     return true;
    //   else 
    //     return false;
    // },
    isAdmin() {
      if (this.userContext == null) return false;
      return this.userContext.contextName == 'ADMIN';
    },
    isMgr() {
      if (this.userContext == null) return false;
      return this.userContext.contextName == 'MANAGER';
    },
    isMobileDevice() {
      var isMobile = navigator.maxTouchPoints ? true: false;
      console.log("isMobile: " + isMobile); // eslint-disable-line no-console
    
      return isMobile;
    },
    links() {
      let links = [
        { icon: "mdi-home", text: 'Home', route: "/", disabled: false, exact: true },
        { icon: "mdi-egg", text: 'Egg Collection', route: "/eggGroups", disabled: false, exact: true },
        { icon: "mdi-camera", text: 'Egg Vision', route: "/eggVision", disabled: false, exact: true },
        { icon: "mdi-magnify", text: 'Bird Lookup', route: "/birdLookup", disabled: false, exact: true },
        { icon: "mdi-clipboard-pulse-outline", text: 'Reports', route: "/Reports", disabled: false, exact: true }
      ];

      links = [...links,
        { icon: "mdi-wrench", text: 'Administration', route: {name: 'Administration', params:{check:true}}, disabled: !this.isAdmin && !this.isMgr, exact: true }
      ];
      return links;
    },

    links2() {
      let links = [
        { icon: "mdi-database", text: 'Local Storage', route: "/localstorage", disabled: !this.isAdmin && !this.isMgr, exact: true },
        { icon: "mdi-file-document-multiple", text: 'Documents', route: "/documents", disabled: false, exact: true },
        { icon: "mdi-cog", text: 'Settings', route: "/settings", disabled: false, exact: true }
      ];
      return links;
    },
    orientation() {
      var orientation = this.settings.orientation;
      return (orientation ? orientation : 'natural');
    },
    userContext() {
      return this.settings.userContext;
    }
  },
  methods: {
    handleScreenChange() {
      if( (screen.availHeight || screen.height-30) <= window.innerHeight) {
        this.isFullScreen = true;
      }
      else this.isFullScreen = false;
    },
    async toggleScreen() {
      try {
        if (this.isFullScreen) {
          document.webkitExitFullscreen();
          await screen.orientation.unlock();
          this.isFullScreen = false;
        }
        else {
          const body = document.getElementsByTagName("BODY")[0];
          body.webkitRequestFullscreen();
          if (this.orientation != 'natural') await screen.orientation.lock(this.orientation);
          this.isFullScreen = true;
        }
      }
      catch (error) {
        this.$root.showNoticeError(error.message);
      }
    }
  }
}
</script>

<style scoped>
  img.nav-icon:hover {
    cursor: pointer;
  }
</style>